import { config } from '@/config';

type AuthTracePayload = {
  event: string;
  correlationId?: string;
  userId?: string | null;
  path?: string;
  detail?: Record<string, unknown>;
};

const endpoint = `${config.apiBaseUrl.replace(/\/+$/, '')}/debug/auth-trace`;

const isEnabled = (): boolean => import.meta.env.DEV;

export const emitAuthTrace = (payload: AuthTracePayload): void => {
  if (!isEnabled()) return;
  const body = JSON.stringify({
    ...payload,
    path: payload.path ?? window.location.pathname + window.location.search,
  });
  try {
    if (typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function') {
      const blob = new Blob([body], { type: 'application/json' });
      navigator.sendBeacon(endpoint, blob);
      return;
    }
  } catch {
    // Fall through to fetch.
  }
  void fetch(endpoint, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body,
    keepalive: true,
  }).catch(() => {
    // Best-effort trace only; never break auth flow.
  });
};
